module.exports = __webpack_public_path__ + "static/media/spirulina.7c00fea7.jpg";